import { useEffect, useState } from 'react';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section id="hero" className="relative w-full" style={{ minHeight: '100vh' }}>
      {/* Background image */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20private%20beauty%20salon%20treatment%20room%20with%20elegant%20white%20bed%2C%20soft%20natural%20lighting%2C%20minimalist%20interior%20with%20cream%20and%20white%20tones%2C%20clean%20professional%20esthetic%20space%2C%20high-end%20serene%20atmosphere%2C%20delicate%20fresh%20flowers%20on%20side%20table%2C%20pure%20white%20linens%2C%20wooden%20floor%2C%20large%20window%20with%20sheer%20curtains&width=1400&height=900&seq=hero001&orientation=landscape"
          alt="プライベートサロン施術室"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-charcoal/60 via-charcoal/40 to-charcoal/50" />
        {/* Subtle gold vignette */}
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/30 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center min-h-screen px-8 sm:px-16 lg:px-24 pt-20">
        <div
          className={`max-w-2xl transition-all duration-1000 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Section label */}
          <p
            className="section-label mb-6"
            style={{ color: '#C9A96E', letterSpacing: '0.3em', fontSize: '11px' }}
          >
            PRIVATE BEAUTY SALON
          </p>

          {/* Main catchcopy */}
          <h1 className="font-serif-jp text-offwhite hero-text-shadow mb-6 leading-relaxed">
            <span className="block" style={{ fontSize: 'clamp(28px, 5vw, 52px)' }}>
              一人ひとりに寄り添う、
            </span>
            <span className="block" style={{ fontSize: 'clamp(28px, 5vw, 52px)' }}>
              静かな隠れ家サロン。
            </span>
            <span
              className="block mt-2 font-light"
              style={{ fontSize: 'clamp(18px, 3vw, 32px)', color: '#E8D5A3' }}
            >
              確かな技術を、落ち着いた空間で。
            </span>
          </h1>

          {/* Gold divider */}
          <div className="gold-divider mb-6" />

          {/* Sub copy */}
          <p
            className="font-sans-jp text-offwhite/85 tracking-wider leading-loose"
            style={{ fontSize: 'clamp(13px, 1.8vw, 16px)', letterSpacing: '0.12em' }}
          >
            完全個室　/　認定エステティシャン在籍　/　強引な勧誘なし
          </p>
        </div>

        {/* Scroll indicator */}
        <div
          className={`absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 transition-all duration-1000 delay-500 ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <span className="text-offwhite/60 font-sans-jp" style={{ fontSize: '11px', letterSpacing: '0.2em' }}>
            SCROLL
          </span>
          <div className="w-px h-12 bg-gradient-to-b from-gold/60 to-transparent" />
        </div>
      </div>
    </section>
  );
}
